import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import CaseStudies from './components/CaseStudies/CaseStudies';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import CursorTrail from './components/common/CursorTrail';
import PrivacyPolicy from './pages/PrivacyPolicy';
import './styles/App.css';
import './styles/image-enhancements.css';

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
    });
  }, []);

  // Home Page Component
  const HomePage = () => (
    <>
      <Header />
      <Hero />
      <About />
      <CaseStudies />
      <Contact />
      <Footer />
    </>
  );

  return (
    <Router>
      <div className="App">
        <CursorTrail />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
        {/* <PerformanceMonitor /> */}
      </div>
    </Router>
  );
};

export default App;